import * as React from 'react';
import TableCell from '@mui/material/TableCell';

export default function ReportingTableColumn ({labelIndex, valueSet}) {
  return (
    <>       
      <TableCell align="right" sx={{pr:1, minWidth: 120}}>{valueSet[labelIndex]}</TableCell>
    </>
  );
}